/* ============================================================
   CUSTOM ORDERS — LEAD FORM (<co-lead-form>)
   Ported from pins-aces-custom.vercel.app (assets/klaviyo.js + script.js).

   FLOW:
     form -> Klaviyo client subscribe (primary capture; timestamps consent,
             adds profile to the list)
          -> Klaviyo custom event "Custom Order Request Submitted"
          -> a Klaviyo FLOW sends the internal notify to custom@pinsandaces.com
   The notify email is handled INSIDE Klaviyo, not here. Do not POST to
   custom@pinsandaces.com from this file.

   Credentials come from the section settings via data attributes
   (data-company-id = Klaviyo public API key, data-list-id).
   ============================================================ */
(function () {
  "use strict";

  var API_REVISION = "2024-10-15";

  function subscribe(companyId, listId, data) {
    var payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Custom Order Landing Page",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: data.email,
                phone_number: data.phone || undefined,
                first_name: data.name,
                organization: data.company,
                properties: {
                  custom_company_club: data.company,
                  custom_project_description: data.description,
                  custom_estimated_quantity: data.quantity || "",
                  custom_lead_source: "custom_order_page"
                }
              }
            }
          }
          /* Consent: only called after the user ticks the (non-pre-checked) box.
             Subscribing via the client endpoint records marketing consent +
             timestamp server-side. Do NOT add a `subscriptions` block here —
             this endpoint rejects it (400 "not a valid field"). */
        },
        relationships: {
          list: { data: { type: "list", id: listId } }
        }
      }
    };
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + companyId, {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: API_REVISION },
      body: JSON.stringify(payload)
    });
  }

  /* Custom metric so a Klaviyo flow can trigger the internal notification
     email. Gives sales a clean "Custom Order Request Submitted" event. */
  function trackEvent(companyId, data) {
    var payload = {
      data: {
        type: "event",
        attributes: {
          properties: {
            company_club: data.company,
            project_description: data.description,
            estimated_quantity: data.quantity || "",
            phone: data.phone || ""
          },
          metric: { data: { type: "metric", attributes: { name: "Custom Order Request Submitted" } } },
          profile: { data: { type: "profile", attributes: { email: data.email, first_name: data.name } } }
        }
      }
    };
    return fetch("https://a.klaviyo.com/client/events/?company_id=" + companyId, {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: API_REVISION },
      body: JSON.stringify(payload)
    });
  }

  function submitLead(companyId, listId, data) {
    if (!companyId || !listId) {
      console.warn("[co-lead-form] Klaviyo company ID / list ID missing on section settings. Payload:", data);
      return Promise.resolve({ dev: true });
    }
    return subscribe(companyId, listId, data).then(function (res) {
      if (!res.ok) throw new Error("Klaviyo subscribe failed: " + res.status);
      return trackEvent(companyId, data).catch(function (e) {
        // Don't fail the lead if only the event ping errors — subscription already saved.
        console.warn("[co-lead-form] event track failed (non-fatal):", e);
      });
    });
  }

  if (customElements.get("co-lead-form")) return;
  customElements.define("co-lead-form", class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("form");
      this.msg = this.querySelector("[data-msg]");
      this.submitBtn = this.querySelector('button[type="submit"]');
      if (!this.form) return;
      this.submitLabel = this.submitBtn ? this.submitBtn.textContent : "";
      this.form.addEventListener("submit", this.onSubmit.bind(this));
    }

    setMsg(text, type) {
      if (!this.msg) return;
      this.msg.textContent = text;
      this.msg.className = "co-form__msg" + (type ? " " + type : "");
    }

    onSubmit(e) {
      e.preventDefault();
      var form = this.form;
      var self = this;
      this.setMsg("", "");

      if (!form.checkValidity()) {
        form.querySelectorAll(":invalid").forEach(function (el) { el.classList.add("invalid"); });
        this.setMsg("Please complete the required fields and agree to be contacted.", "error");
        form.reportValidity();
        return;
      }
      form.querySelectorAll(".invalid").forEach(function (el) { el.classList.remove("invalid"); });

      var data = {
        name: form.name.value.trim(),
        email: form.email.value.trim(),
        company: form.company.value.trim(),
        phone: form.phone.value.trim(),
        description: form.description.value.trim(),
        quantity: form.quantity.value.trim(),
        consent: form.consent.checked
      };

      if (this.submitBtn) {
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = "Submitting…";
      }

      submitLead(this.dataset.companyId, this.dataset.listId, data)
        .then(function (res) {
          form.reset();
          if (res && res.dev) {
            self.setMsg("Form works. Klaviyo not yet configured (see console). Thanks!", "success");
          } else {
            self.setMsg("Thanks! Your request is in. Our team will reach out shortly.", "success");
          }
        })
        .catch(function (err) {
          console.error(err);
          self.setMsg("Something went wrong submitting your request. Please try again or email custom@pinsandaces.com.", "error");
        })
        .finally(function () {
          if (self.submitBtn) {
            self.submitBtn.disabled = false;
            self.submitBtn.textContent = self.submitLabel;
          }
        });
    }
  });
})();
